<template>
  <div
    class="grid grid-cols-1 grid-rows-1 p-16 lg:grid-cols-[max-content,auto,max(18.5rem)] lg:p-32"
  >
    <div class="flex size-full flex-col">
      <div class="flex size-full flex-row space-x-8">
        <OrderlineCardProduct
          :orderline-id="orderline.orderlineId"
          :product="orderline.product"
        />

        <OrderlineCardHeader
          class="block lg:hidden"
          :order-id="orderline.orderId"
          :orderline-price="orderline.price"
          :orderline-state="orderline.state"
          :orderline-tag="orderline.tag"
          :product-title="orderline.product.title"
        />
      </div>

      <RevDivider class="my-24 block lg:hidden" />
    </div>

    <div
      class="flex size-full flex-col lg:justify-start lg:py-0 lg:pl-24 lg:pr-56"
    >
      <OrderlineCardHeader
        class="hidden lg:mb-24 lg:mt-32 lg:block"
        :order-id="orderline.orderId"
        :orderline-price="orderline.price"
        :orderline-state="orderline.state"
        :orderline-tag="orderline.tag"
        :product-title="orderline.product.title"
      />

      <OrderlineCardContent
        :express-replaced-by-replacement-orderline="
          orderline.expressReplacedByReplacementOrderline
        "
        :express-replacement-return-window="
          orderline.expressReplacementReturnWindow
        "
        :orderline-state="orderline.state"
        :refund-date="orderline.refundDate"
        :replacement-orderline="orderline.replacedByReplacementOrderline"
        :timeline="orderline.timeline"
      />
    </div>

    <div class="flex h-full flex-col justify-center">
      <OrderlineCardActions
        :orderline-actions="orderline.actions"
        :orderline-id="orderline.orderlineId"
        :public-id="orderline.publicId"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { RevDivider } from '@ds/components/Divider'

import OrderlineCardActions from '../OrderlineCardActions/OrderlineCardActions.vue'
import OrderlineCardContent from '../OrderlineCardContent/OrderlineCardContent.vue'
import OrderlineCardHeader from '../OrderlineCardHeader/OrderlineCardHeader.vue'
import OrderlineCardProduct from '../OrderlineCardProduct/OrderlineCardProduct.vue'

import type { OrderlineContainerProps } from './OrderlineContainer.types'

defineProps<OrderlineContainerProps>()
</script>
